export default {
  ar() {
    return {
      link: 'Click here',
      description: 'to read and agree to your terms and conditions.',
      finePrint: 'This link will take you to docusign.com. Upon completion of your signed terms and conditions, you will be returned to this page to complete your purchase.',
      sectionTitle: 'الشروط و البنود',
      button: 'عرض الأحكام و الشروط'
    }
  },
  de() {
    return {
      link: 'Klicken Sie hier,',
      description: 'um unsere AGB zu lesen und zu akzeptieren.',
      finePrint: 'This link will take you to docusign.com. Upon completion of your signed terms and conditions, you will be returned to this page to complete your purchase.',
      sectionTitle: 'Allgemeine Geschäftsbedingungen',
      button: 'Allgemeine Geschäftsbedingungen anzeigen'
    }
  },
  en() {
    return {
      link: 'Click here',
      description: 'to read and agree to your terms and conditions.',
      finePrint: 'This link will take you to docusign.com. Upon completion of your signed terms and conditions, you will be returned to this page to complete your purchase.',
      sectionTitle: 'Terms and Conditions',
      button: 'View Terms & Conditions'
    }
  },
  enGB() {
    return {
      link: 'Click here',
      description: 'to read and agree to your terms and conditions.',
      finePrint: 'This link will take you to docusign.com. Upon completion of your signed terms and conditions, you will be returned to this page to complete your purchase.',
      sectionTitle: 'Terms and Conditions',
      button: 'View Terms & Conditions'
    }
  },
  esMX() {
    return {
      link: 'Haga clic aquí',
      description: 'para leer y aceptar nuestros términos y condiciones.',
      finePrint: 'This link will take you to docusign.com. Upon completion of your signed terms and conditions, you will be returned to this page to complete your purchase.',
      sectionTitle: 'Términos y Condiciones',
      button: 'Ver Términos y Condiciones'
    }
  },
  fr() {
    return {
      link: 'Veuillez cliquer ici',
      description: 'pour lire et accepter nos termes et conditions.',
      finePrint: 'This link will take you to docusign.com. Upon completion of your signed terms and conditions, you will be returned to this page to complete your purchase.',
      sectionTitle: 'Termes et Conditions',
      button: 'Voir les Conditions générales d\'utilisation'
    }
  },
  it() {
    return {
      link: 'Clicca qui',
      description: 'per leggere e accettare i termini e le condizioni.',
      finePrint: 'This link will take you to docusign.com. Upon completion of your signed terms and conditions, you will be returned to this page to complete your purchase.',
      sectionTitle: 'Termini e condizioni',
      button: 'Visualizza termini e condizioni'
    }
  },
  ja() {
    return {
      link: 'こちらをクリックして、',
      description: '利用規約を読み、同意してください。',
      finePrint: 'This link will take you to docusign.com. Upon completion of your signed terms and conditions, you will be returned to this page to complete your purchase.',
      sectionTitle: 'ご利用規約',
      button: '利用規約はこちら'
    }
  },
  pl() {
    return {
      link: 'Click here',
      description: 'to read and agree to your terms and conditions.',
      finePrint: 'This link will take you to docusign.com. Upon completion of your signed terms and conditions, you will be returned to this page to complete your purchase.',
      sectionTitle: 'regulamin',
      button: 'przeczytaj regulamin'
    }
  },
  zhCN() {
    return {
      link: 'Click here',
      description: 'to read and agree to your terms and conditions.',
      finePrint: 'This link will take you to docusign.com. Upon completion of your signed terms and conditions, you will be returned to this page to complete your purchase.',
      sectionTitle: '条款和条件',
      button: '查看条款与条件'
    }
  }
}
